import { Component, OnInit, ɵConsole } from '@angular/core';
import { Airport } from 'src/app/model/airport';
import { CurrentAptService } from 'src/app/service/current-apt.service';
import { AirportGeneralService } from '../../service/airport-general.service';
import { ApiRequest, Filter, FilterComposit, FilterPredicate, Sort, SortCondition, PageInfo, ApiResponse } from '../../model/api-request';
import { AirportScheduleService } from 'src/app/service/airport-schedule.service';
import { AirportSchedule } from 'src/app/model/airportSchedule';

@Component({
  selector: 'app-airport-general',
  templateUrl: './airport-general.component.html',
  styleUrls: ['./airport-general.component.css']
})
export class AirportGeneralComponent implements OnInit
{
  public apiRequest: ApiRequest;
  public apiResponse: ApiResponse;
  public airportArray: Airport[];
  public scheduleArray: AirportSchedule[];

  public airport: Airport;
  public currentAirport: string;
  public latitude = 51.673858 ;
  public longitude = 7.815982;
  public hybrid = 'hybrid';
  public zoom = 12;

  constructor(private data: CurrentAptService,
              private airportGeneralService: AirportGeneralService,
              private airportScheduleService: AirportScheduleService
    ) { }

  ngOnInit() {
    this.data.currentAirport.subscribe(currentLocid => this.currentAirport = currentLocid);

    this.apiRequest = new ApiRequest();

    let filterPredicate1: Array<FilterPredicate>;
    let filterCompositArray: Array<FilterComposit>;
    let sortConditionArray: Array<SortCondition>;

    filterPredicate1 = [new FilterPredicate('AirportIdentifier', 'String', this.currentAirport, 'IsEqualTo')];
    filterCompositArray = [new FilterComposit(filterPredicate1, 'Or')];
    this.apiRequest.filter = new Filter(filterCompositArray, 'And');

    sortConditionArray = [new SortCondition('airportIdentifier', 'Ascending')];
    this.apiRequest.sort = new Sort(sortConditionArray);

    this.apiRequest.pageInfo = new PageInfo(0, 1, 5); // SQL 2008 requires 0, 0, 0
    this.airportGeneralService.getMultiple(this.apiRequest).subscribe((result => {
    this.airportArray = result.data as Airport[];
    this.airport = this.airportArray[0];
    this.latitude = this.convertDMSToDD(this.airport.arptLat);
    this.longitude = this.convertDMSToDD(this.airport.arptLong);



    filterPredicate1 = [new FilterPredicate('FaaSite', 'String', this.airport.faaSite, 'IsEqualTo')];
    filterCompositArray = [new FilterComposit(filterPredicate1, 'Or')];
    this.apiRequest.filter = new Filter(filterCompositArray, 'And');

    sortConditionArray = [new SortCondition('AttSequence', 'Ascending')];
    this.apiRequest.sort = new Sort(sortConditionArray);

    this.airportScheduleService.getMultiple(this.apiRequest).subscribe((result2 =>{
    this.scheduleArray = result2.data as  AirportSchedule[];

      }));
    }));




    }

  convertDMSToDD(dms) {
    const parts = dms.split(/[^\d\w\.]+/);
    const degrees = parseFloat(parts[0]);
    const minutes = parseFloat(parts[1]);
    const seconds = parseFloat(parts[2]);
    const direction =parts[2].slice(-1);

    let dd = degrees + minutes / 60 + seconds / (60 * 60);

    if (direction === 'S' || direction === 'W') {
      dd = dd * -1;
    } // Don't do anything for N or E
    return dd;
  }
}
